import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Page404 from '../../../../Page404/Page404';
import Initial from './Initial/Initial';
import OrderWrapper from './OrderWrapper';
import { createDataLayer } from '../../../../DataLayerAnalytics/orderDataLayerInstance';
import { OrderType } from '../../../../DataLayerAnalytics/OrderDataLayer/types';
import { useCurrentUser } from '../../../../CurrentUser/CurrentUser.hooks';

const Checkin: React.FC = () => {
	createDataLayer(OrderType.Checkin);

	useCurrentUser();

	const pnr = '[0-9БВГДКЛМНПРСТФХЦЖШA-Z]{6,6}';
	const ticketNumber = '[0-9A-ZА-Я]{13,13}';
	const lastName = '[\\wА-яA-z\\s-—]+';
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t('Title:companyName')}</title>
			</Helmet>

			<Switch>
				<Route path="/" exact component={Initial} />
				<Route path="/:id(\d+)" render={({ match }) => <OrderWrapper orderId={match.params.id} />} />
				<Route
					path={[
						`/search/:PNR(${pnr})?/:lastName(${lastName})?`,
						`/search/:PNR(${ticketNumber})?/:lastName(${lastName})?`,
						`/search/:PNR(${pnr})?/:lastName(${lastName})?/submit`,
						`/search/:PNR(${ticketNumber})?/:lastName(${lastName})?/submit`
					]}
					exact
					component={Initial}
				/>
				<Page404 onClick={() => (window.location.href = '/')} />
			</Switch>
		</>
	);
};

export default Checkin;
